import React, { Component } from 'react';
import styled from 'styled-components';

interface Props {
	disable?: boolean;
	index?: number;
	handleSubmit?: Function;
	eachOption: any;
	voiceResponse: boolean;
	isUser?: boolean;
	channel?: string;
	data: any;
	configData: any;
}

interface State {
	data: any;
}
// color: ${(props: any) => {
// 	return props.foreground;
// }};
const MultiItem = styled.button`
	padding: 0;
	border-radius: 16px !important;
	background-color: #fff !important;
	&:focus-visible:before {
		position: absolute;
		inset: 0;
		content: '';
		left: 0;
		top: 0;
		background-color: ${(props: any) => {
		return props.colorScale && props.colorScale[9];
	}};
	}
	// &:hover:before {
	// 	position: absolute;
	// 	inset: 0;
	// 	content: '';
	// 	left: 0;
	// 	top: 0;
	// 	background-color:rgba(0, 0, 0, 0.4);
	// }

	// &:active:before {
	// 	position: absolute;
	// 	inset: 0;
	// 	content: '';
	// 	left: 0;
	// 	top: 0;
	// 	background-color:rgba(0, 0, 0, 0.4);
	// }

	& > span {
		padding: 6px 16px;

		color: ${(props: any) => {
		return props.colorScale && props.colorScale[2];
	}};
		border: 1px solid
			${(props: any) => {
		return props.colorScale && props.colorScale[6];
	}};
	}
`;

const styleVars = getComputedStyle(document.querySelector(':root'));

export class MultipleOptions extends Component<Props, State> {
	constructor(props) {
		super(props);
		this.state = {
			data: {},
		};
	}
	componentDidMount(): void {
		this.props.data.listResponseType
			? this.setState({
				data: this.props.configData,
			})
			: this.setState({
				data: this.props.data,
			});
	}
	render() {
		let background =
			styleVars.getPropertyValue('--optionsBackground') || '#383ff6';
		let border = styleVars.getPropertyValue('--optionsBorder') || '#ffffff66';
		let foreground = styleVars.getPropertyValue('--optionsColor') || '#ffffff';
		let usrforeground = this.props.isUser
			? styleVars.getPropertyValue('--inputBoxColor') || '#000000'
			: foreground;
		let usrBackground = this.props.isUser
			? styleVars.getPropertyValue('--inputBackground') || '#ffffff'
			: background;
		// console.log(this.props.eachOption)
		return (
			<MultiItem
				{...{
					background: usrBackground,
					foreground: usrforeground,
					usrforeground: usrforeground,
					border: border,
					...this.state.data,
				}}
				className={` ${this.props.channel === 'whatsapp'
					? this.props.eachOption.title
						? 'whatsapp-multi-choice-option'
						: 'whatsapp-disamb-quicklinks'
					: 'multi-choice-option'
					} clickable body-text-1 ${this.props.disable ? 'action-disabled' : ''}`}
				disabled={this.props.disable}
				key={this.props.index ? this.props.index : null}
				onClick={() =>
					this.props.handleSubmit(
						this.props.eachOption.actionText || this.props.eachOption.title
							? this.props.eachOption.actionText || this.props.eachOption.title
							: this.props.eachOption
					)
				}
			>
				<span className={`body-text-1`}>
					{this.props.eachOption.displayText
						? this.props.eachOption.displayText
						: this.props.channel === 'whatsapp'
							? this.props.eachOption.title
								? this.props.eachOption.title
								: this.props.eachOption
							: this.props.eachOption}
				</span>
			</MultiItem>
		);
	}
}

export default MultipleOptions;
